export default __webpack_public_path__ + "static/media/location.949dce1a.svg";